<py-header-navigation-item
  *ngIf="{ hasMultipleCarts: hasMultipleCarts$ | async, numberOfEntries: numberOfEntries$ | async } as data"
>
  <i class="reset" nz-icon nzType="shopping-cart" nzTheme="outline"></i>
  <span class="navigation-cart-title">{{ 'navigation.cart_title' | cxTranslate }}</span>
  <py-tiny-multiple-cart-badge
    *ngIf="data.hasMultipleCarts; else templateSingleCart"
    [numberOfEntries]="data.numberOfEntries"
  ></py-tiny-multiple-cart-badge>

  <ng-template #templateSingleCart>
    <py-badge *ngIf="data.numberOfEntries > 0" [isNotification]="true" [position]="'top-right'">
      {{ data.numberOfEntries }}
    </py-badge>
  </ng-template>
</py-header-navigation-item>

<ng-template #cartDrawer>
  <py-cart-drawer></py-cart-drawer>
</ng-template>
